/**
 * Constantes transversales del frontend.
 */

/**
 * Tamaño de página que piden los SELECTORES (desplegables de cliente,
 * oportunidad, etc.) que cargan toda la lista de una vez. Antes pedían 100
 * —el techo del backend—, así que en una compañía con más de 100 clientes u
 * oportunidades los registros extra desaparecían del desplegable sin aviso.
 * El backend admite hasta 500 (ver ClientListQuerySchema / OpportunityListQuerySchema).
 *
 * Nota: sigue siendo un techo. Si alguna compañía supera los 500, el arreglo
 * definitivo es un combobox con búsqueda server-side (?q=), que ambos
 * endpoints ya soportan.
 */
export const SELECTOR_PAGE_SIZE = 500
